import {frontPath, studentLoginUrl, studentLoginUrlWithSchoolCode} from "constant/constant";
import path from 'path'
import axios from "utils/new_request";
import { xauthApi } from "../constants/constants";
export function getUrlParam (paramKey) {
    //获取地址参数值
    var search = decodeURIComponent(window.location.search), val, params;
    if (search && search.length > 1) {
        search = search.slice(1);
        params = search.split('&');
        for (var i = 0; i < params.length; i++) {
            var param = params[i];
            if (param.split('=').length && String(param.split('=')[0]) === String(paramKey)) {
                val = String(param.split('=')[1])=='undefined'?'':String(param.split('=')[1]);
                break;
            }
        }
    }
    return val ? decodeURIComponent(val) : '';
}
export function getFirstErrorKeyValue(data) {
    let result = {};
    for(var i in data){
        result.key = i;
        result.value = data [i][0];
        break;
    }
    return result;
}
export function  transStringToArray(str) {
    let list = str.split(','),result = [];
    list.map((item,i)=>{
        result.push({id:item,name:item})
    })
    return result
}

export const getLocalData = function (data, isRemoveFlag = false) {
    const value =JSON.parse(window.localStorage.getItem(data));
    // console.log('get', window.localStorage.getItem(data))
    if (value === 'undefined') {
        delLocalData(data);
        return;
    }
    isRemoveFlag && delLocalData(data);
    return value
};
export const delLocalData = function (data) {
    window.localStorage.removeItem(data);
    // console.log('del', window.localStorage.getItem(data));
    return;
};
export const setLocalData = function (data, value) {
        window.localStorage.setItem(data, JSON.stringify(value));
        // console.log('set', window.localStorage.getItem(data));
        return;
};

export const hasUserDetail=function (data){
    if(getLocalData(data)){
        return getLocalData(data)
    }else {
        return {}
       // axios.get('/sjsy/api/user/detail').then(d=>{
       //      if(d.user && d.user.roles && d.user.roles.length>0 && d.user.roles[0].name!='student'){
       //          alert('非学生端账号，请重新登录。');
       //          if(getUrlParam('schoolCode')){
       //              let urlArr=studentLoginUrl.split('?');
       //              window.location=`${urlArr[0]}?schoolCode=${getUrlParam('schoolCode')}&${urlArr[1]}`
       //          }else {
       //              window.location = studentLoginUrlWithSchoolCode();
       //          }
       //      }
       //      else if(!d.student || Object.keys(d.student).length===0){
       //          window.location=studentLoginUrlWithSchoolCode();
       //      }
       //      else if(d.student && Object.keys(d.student).length>0){
       //          setLocalData('user_detail', d);
       //          debugger
       //          return d
       //      }
       //  })
    }
}

export const getSessionData = function (data, isRemoveFlag = false) {
    const value = JSON.parse(window.sessionStorage.getItem(data));
    // console.log('get', window.localStorage.getItem(data))
    if (value === 'undefined') {
        delSessionData(data);
        return;
    }
    isRemoveFlag && delSessionData(data);
    return value
};
export const delSessionData = function (data) {
    window.sessionStorage.removeItem(data);
    // console.log('del', window.localStorage.getItem(data));
    return;
};
export const setSessionData = function (data, value) {
    window.sessionStorage.setItem(data, JSON.stringify(value));
    // console.log('set', window.localStorage.getItem(data));
    return;
};

export const setLocalDataTimeLimit = function (key, value) {

    var nowTime = new Date().getTime();
    var data = { value: value, expire: nowTime + 24*60*60*1000 }//设置一天过期
    // var data = { value: value, expire: nowTime + 10*60*1000 }//设置10分钟过期
    window.localStorage.setItem(key, JSON.stringify(data))
    return;
};
export const getLocalDataTimeLimit=function (key){
    var data = JSON.parse(window.localStorage.getItem(key));
    if (data !== null) {
        if (data.expire != null && data.expire < new Date().getTime()) {
            window.localStorage.removeItem(key)
        } else {
            return data.value
        }
    }
    return null
}

export const isObject = function (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
export const isEmptyObject = function (obj) {
    for (let t in obj)
        return !1;
    return !0;
};
export const setDocTitle = function (title) {
    if (!title) {
        return;
    }
    document.title = title;
    // const iframe = document.createElement('iframe');
    // iframe.src = require('../static/img/back.png');
    // iframe.style.display = 'none';
    // iframe.onload = function () {
    //     setTimeout(function () {
    //         iframe.remove();
    //     });
    // }
    // document.body.appendChild(iframe);
}
export const createUUID = function (){
    let s = [];
    let  hexDigits = "0123456789abcdef";
    for (let  i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    let uuid = s.join("");
    return uuid;
}
function add0(m){return m<10?'0'+m:m }
export const unixTimesTamp = function (tamp){
    var time = new Date(tamp);
    var y = time.getFullYear();
    var m = time.getMonth()+1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
}
export const isProvince = function (str) {
    let cityList=['北京','天津','上海','重庆'];
    if(cityList.includes(str)){
        return str+'市'
    }
    return str+'省'
};
export const debounce =function (fn, ms) {
    let timeoutId;
    return function () {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            fn.apply(this, arguments)
        }, ms)
    }
};
export const dateVerify=function (data) {
    let subYY='',separate='',area='',subMM='',subDD='',NewDate='';
    let regExp=new RegExp(/(\d{4}-)(\d{2}-)(\d{2})$/);
    if(data==""||data.length!=10||!regExp.test(data)){//空值 长度校验
        return true;
    }
    subYY=data.substr(0,4)
    if(isNaN(subYY)||subYY<=0){
        return true;
    }
    // 转换月份
    if(data.indexOf('-',0)!=-1){
        separate="-"
    }else{
        return true;
    }
    area=data.indexOf(separate,0)
    subMM=data.substr(area+1,data.indexOf(separate,area+1)-(area+1))
    if(isNaN(subMM)||subMM<=0){
        return true;
    }
    // if(subMM.length<2){subMM="0"+subMM}
    // 转换日
    area=data.lastIndexOf(separate)
    subDD=data.substr(area+1,data.length-area-1)
    if(isNaN(subDD)||subDD<=0){
        return true;
    }
    // if(eval(subDD<10)){subDD="0"+eval(subDD)}
    NewDate=subYY+"-"+subMM+"-"+subDD
    if(NewDate.length!=10){
        return true;
    }
    if(NewDate.substr(4,1)!="-"){
        return true;
    }
    if(NewDate.substr(7,1)!="-"){
        return true;
    }
    var MM=NewDate.substr(5,2);
    var DD=NewDate.substr(8,2);
    if((subYY%4==0&&subYY%100!=0)||subYY%400==0){//判断是否为闰年
        if(parseInt(MM)==2){//闰年的二月份
            if(DD>29){
                return true;
            }
        }
    }else{
        if(parseInt(MM)==2){//非闰年的二月份
            if(DD>28){
                return true;
            }
        }
    }
    var mm=new Array(4,6,9,11);//判断每月中最大天数是30或者31
    for(let i=0;i<mm.length;i++){
        if(parseInt(MM)==mm[i]){
            if(parseInt(DD)>30){
                return true;
            }
        }else{
            if(parseInt(DD)>31){
                return true;
            }
        }
    }
    if(parseInt(MM)>12){
        return true;
    }
    return false;
}
export const transformDate = function (date){
    var time = new Date(date);
    var y = time.getFullYear();
    var m = time.getMonth()+1;
    var d = time.getDate();
    return y+'-'+add0(m)+'-'+add0(d);
}
export const isRepeat=function (arr){
    var hash = {};
    for(var i in arr) {
        if(hash[arr[i]])
            return true;
        hash[arr[i]] = true;
    }
    return false;
}
//找出重复的元素
export const duplicates=function (arr) {
    let temp=[]
    arr.forEach(item=>{
        if(arr.indexOf(item) != arr.lastIndexOf(item) && temp.indexOf(item) == -1){
            temp.push(item);
        }
    })
    return temp
}
// 家长端的页面路由都是以/parents开头 路由命名时需要注意
export const isParentPage = function () {
    return window.location.pathname.startsWith(path.join(frontPath, '/parents'))
}
export const isParentDomain = function () {
    return window.location.hostname.startsWith('jz.')
}



// WEBPACK FOOTER //
// ./src/utils/util.js